import axios from 'axios';
import Selector from '../components/Selector';
import Observable from '../utils/Observable';

class Table {
  constructor(container, data) {
    console.log('Table');
    this.observable = new Observable();
    this.container = container;
    this.dataContainer = this.container.querySelector('.table-data-container');
    this.headers = this.container.querySelectorAll('[data-filter]');
    this.expanderButton = this.container.querySelector('.expander');
    this.tableSelect = this.container.querySelector('.table-select');
    this.selector = new Selector(this.container.querySelector('.table-select'), this.observable, 'column-selected');
    this.displayAll = false;
    this.minAmount = 8;
    this.data;
    this.sortedData = [];
    
    this.init();
    
    this.sortDataByProperty = this.sortDataByProperty.bind(this);
    this.handleHeaderClick = this.handleHeaderClick.bind(this);
    this.handleExpander = this.handleExpander.bind(this);
    this.toggleContentExpand = this.toggleContentExpand.bind(this);
    this.handleSelectColumn = this.handleSelectColumn.bind(this);

    this.observable.subscribe('column-selected', this.handleSelectColumn);
  }

  init() {
    axios.get('/api/universities')
      .then(res => {
        this.data = res.data.data;
        const sortOptions = [
          { text: 'Continued Studies: High to Low', value: 'continuedStudies-desc' },
          { text: 'Continued Studies: Low to High', value: 'continuedStudies-asc' },
          { text: 'Total Number of Reported Cases: High to Low', value: 'totalOffences-desc' },
          { text: 'Total Number of Reported Cases: Low to High', value: 'totalOffences-asc' },
          { text: 'University: A to Z', value: 'university-asc' },
          { text: 'University: Z to A', value: 'university-desc' }
        ];

        const dict = {
          value: 'value',
          text: 'text'
        };

        this.selector.init(sortOptions, dict);

        const totals = this.data.reduce((acc, curr) => {
          return {
            to: acc.to + curr.totalOffences,
            cs: acc.cs + curr.continuedStudies
          }
        }, { to: 0, cs: 0 });

        console.log('to', totals);

        this.sortDataByProperty('totalOffences', 'desc');
        this.bindEventListeners();
      });
  }

  bindEventListeners() {
    for (let i = 0, len = this.headers.length; i < len; i++) {
      this.headers[i].addEventListener('click', this.handleHeaderClick);
    }

    this.expanderButton.addEventListener('click', this.handleExpander);
  }

  renderTable(data) {
    if (!this.displayAll) {
      data = data.slice(0, this.minAmount);
    }
    
    let rows = this.renderRows(data);
    let showMore = this.container.querySelectorAll('.table__content-reveal');

    if (showMore.length > 0) {
      for (let i = 0, len = showMore.length; i < len; i++) {
        showMore[i].removeEventListener('click', this.toggleContentExpand);
      }
    }
    
    // clear table
    this.dataContainer.innerHTML = '';
    this.dataContainer.innerHTML = rows;

    showMore = this.container.querySelectorAll('.table__content-reveal');

    for (let i = 0, len = showMore.length; i < len; i++) {
      showMore[i].addEventListener('click', this.toggleContentExpand);
    }
  }

  renderHeaders(headers) {
    return `
      <tr>
        ${headers.map(h => `
          <th>${h} <button type="button">asc</button> <button type="button">desc</button></th>
        `).join('')}
      </tr>
    `;
  }

  renderRows(rows) {
    return `
      ${rows.map(r => this.renderRow(r)).join('')}
    `;
  }

  renderRow(row) {
    const {
      university,
      providedOffenceData,
      totalOffences,
      providedContinuedStudies,
      continuedStudies,
      complaintsUpheld,
      hasDataNotes
    } = row;

    const to = providedOffenceData ? totalOffences : hasDataNotes !== null ? hasDataNotes : 'Unknown';
    // const to = providedOffenceData ? totalOffences : 'Unknown';
    const cs = providedContinuedStudies ? continuedStudies : 'Unknown';
    const cu = complaintsUpheld.length
      ? complaintsUpheld
      : (providedContinuedStudies === true && continuedStudies === 0)
        ? ''
        : 'Unknown';

    return `
      <tr>
        <td>${university}</td>
        <td>${to}</td>
        <td>${cs}</td>
        <td>
          <div class="table__content-container">
            ${cu.length >= 140 
              ? (`
                <div class="table__content table__content--hide">
                  ${cu}
                </div>
                <div class="table__content-reveal">Show More</div>
              `)
              : `${cu}`
            }
          </div>
        </td>
      </tr>
    `;
  }

  sortDataByProperty(property, order = 'desc') {
    // reset all headers order
    for (let i = 0, len = this.headers.length; i < len; i++) {
      this.headers[i].setAttribute('data-order', '');
    }
    // set active 
    this.container.querySelector(`[data-property="${property}"]`).setAttribute('data-order', order);

    this.selector.update(`${property}-${order}`);

    this.sortedData = this.sortBy(this.data, property, order);
    this.renderTable(this.sortedData);
  }

  sortBy(data, property, order = 'desc') {
    const copy = Object.assign([], data);
    const direction = order === 'desc' ? -1 : 1;
    const check = property === 'totalOffences' ? 'providedOffenceData' : property === 'continuedStudies' ? 'providedContinuedStudies' : '';
    let sortDict;

    if (check) {
      sortDict = [{
        prop: property,
        direction: direction
      },
      {
        prop: check,
        direction: direction
      }];
    } else {
      sortDict = [{
        prop: property,
        direction: direction
      }];
    }

    return copy.sort((a, b) => {
      let i = 0, result = 0, aa, bb;

      if (!a.hasOwnProperty(property) || !b.hasOwnProperty(property)) return 0; // property doesn't exist

      while (i < sortDict.length && result === 0) {
        aa = (typeof a[sortDict[i].prop] === 'string') ? a[sortDict[i].prop].toUpperCase() : a[sortDict[i].prop];
        bb = (typeof b[sortDict[i].prop] === 'string') ? b[sortDict[i].prop].toUpperCase() : b[sortDict[i].prop];

        result = sortDict[i].direction * (aa < bb ? -1 : (aa > bb ? 1 : 0));
        i++;
      }

      return result;
    });
  }

  handleHeaderClick(e) {
    // TODO: might need a polyfill for 'closest'.
    if(!e.target.closest('[data-filter]')) return;
    e.preventDefault();
    
    const el = e.target.closest('[data-filter]');
    const property = el.getAttribute('data-property');
    const order = el.getAttribute('data-order');
    const o = this.toggleOrder(order);
    
    // sort data
    this.sortDataByProperty(property, o);
  }

  handleSelectColumn(v) {
    const [property, direction] = v.split('-');

    this.sortDataByProperty(property, direction);
  }

  handleExpander() {
    const d = this.sortedData.length ? this.sortedData : this.data;
    this.displayAll = !this.displayAll;
    this.renderTable(d);

    this.expanderButton.innerHTML = this.displayAll ? 'Show less' : 'Show more...';
  }

  toggleOrder(order) {
    if (!order) {
      return 'desc';
    }

    return order === 'asc' ? 'desc' : 'asc';
  }

  toggleContentExpand(e) {
    const button = e.target;
    const parent = button.parentElement;
    const content = parent.querySelector('.table__content');
    const closed = content.classList.contains('table__content--hide');

    button.innerHTML = closed ? 'Show Less' : 'Show More';

    if (closed) {
      content.classList.remove('table__content--hide');
      content.classList.add('table__content--show');
    } else {
      content.classList.remove('table__content--show');
      content.classList.add('table__content--hide');
    }
  }
}

export default Table;